import {SignalLite} from 'signals-lite'
// wp_enqueue_script: Backbone

var FontModel = Backbone.Model.extend({
  idAttribute: 'ID'
})
var FontCollection = Backbone.Collection.extend({
  model: FontModel,
  url: '/wp-json/wp/v2/catalogs?per_page=100&order=asc&orderby=menu_order&_embed'
})

var fullFontCollection = new FontCollection()
fullFontCollection.comparator = 'title'
var filteredFontCollection = fullFontCollection.clone()

// copy the models when loaded (sync gets called on load)
fullFontCollection.on('sync', function () {
  filteredFontCollection.reset(fullFontCollection.models)
})

const FontPageActions = {
  filterByClassification (filter) {
    // Updates FontPageStore through the Backbone.js event system.
    if (filter !== 'all') {
      filteredFontCollection.reset(
        fullFontCollection.filter(function (model) {
          const category = model.attributes._embedded['wp:term']
          return category.length > 0 && category[0].length && category[0][0].slug === filter
        })
      )
    } else {
      filteredFontCollection.reset(
        fullFontCollection.models
      )
    }
    FontPageStore.updateListFilter(filter)
    this.makeListVisible()
  },
  updateAllSampleText (sampleText) {
    FontPageStore.updateAllSampleText (sampleText)
    // this.makeListVisible()
  },
  setFilteredModels (models) {
    FontPageStore.updateListFilter('custom')
    filteredFontCollection.reset(models)
    this.makeListVisible()
  },
  addModelToPage (model) {
    // Triggers `added` event on Backbone.Collection
    filteredFontCollection.add(model)
    // :TODO: Check and see if all the fonts have been added
    // to filtered, and if so, set 'all' filter.
    FontPageStore.updateListFilter('custom')
    this.makeListVisible()
  },
  removeModelFromPage (model) {
    // Triggers `removed` event on Backbone.Collection
    filteredFontCollection.remove(model)
    FontPageStore.updateListFilter('custom')
    this.makeListVisible()
  },
  makeListVisible () {
    FontPageStore.setListVisible()
  },
  makeListHidden () {
    FontPageStore.setListHidden()
  }
}

const FontPageStore = {
  sampleText: '',
  updateAllSampleText (sampleText) {
    this.sampleText = sampleText
    this.allSampleTextChanged.broadcast (this.sampleText, this)
  },
  allSampleTextChanged: new SignalLite(),

  activeFilter: 'all',
  updateListFilter (filter) {
    if (this.activeFilter != filter) {
      this.activeFilter = filter
      this.listFilterChanged.broadcast(filter)
    }
  },
  getListFilter () {
    return this.activeFilter
  },
  listFilterChanged: new SignalLite(),

  updateFullFontList () {
    this.fullFontListChanged.broadcast(fullFontCollection.models)
  },
  getFullFontList () {
    return fullFontCollection.models
  },
  fullFontListChanged: new SignalLite(),

  updateFilteredFontList () {
    this.filteredFontListChanged.broadcast(filteredFontCollection.models)
  },
  getFilteredFontList () {
    return filteredFontCollection.models
  },
  filteredFontListChanged: new SignalLite(),
  pixelRatio: window.devicePixelRatio || 1,
  setPixelRatio (pixelRatio) {
    if (pixelRatio != this.pixelRatio) {
      this.pixelRatio = pixelRatio
      this.pixelRatioChanged.broadcast(pixelRatio)
    }
  },
  getPixelRatio () {
    return this.pixelRatio
  },
  pixelRatioChanged: new SignalLite(),

  isListVisible: /^\/fonts\/?$/.test(window.location.pathname),
  setListVisible () {
    this.isListVisible = true
    this.listVisibilityChanged.broadcast(this.isListVisible)
  },
  setListHidden () {
    this.isListVisible = false
    this.listVisibilityChanged.broadcast(this.isListVisible)
  },
  getListVisibility () {
    return this.isListVisible
  },
  listVisibilityChanged: new SignalLite()
}

// initialize listeners for FontPageStore
window.addEventListener('resize', function (event) {
  FontPageStore.setPixelRatio (window.devicePixelRatio || 1)
})
filteredFontCollection.on('reset', FontPageStore.updateFilteredFontList, FontPageStore)
filteredFontCollection.on('add', FontPageStore.updateFilteredFontList, FontPageStore)
filteredFontCollection.on('remove', FontPageStore.updateFilteredFontList, FontPageStore)
fullFontCollection.on('sync', FontPageStore.updateFullFontList, FontPageStore)
fullFontCollection.on('reset', FontPageStore.updateFullFontList, FontPageStore)
//fullFontCollection.on('add', FontPageStore.updateFullFontList, FontPageStore)
//fullFontCollection.on('remove', FontPageStore.updateFullFontList, FontPageStore)

// bootstrap
if (typeof restResults !== 'undefined') {
  fullFontCollection.reset(restResults)
} else {
  fullFontCollection.fetch()
}

export {fullFontCollection, filteredFontCollection, FontPageActions, FontPageStore}



// WEBPACK FOOTER //
// ./inc/js/actions/actions.js